<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/131iHZm/tc-custom/9780226112428.jpg?1730587135735" alt="This image is the cover for the book Babylonian Genesis"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Babylonian Genesis
      </h1>
      <p class="bookDescription body article font2">
        <p>Here is a complete translation of all the published cuneiform tablets of the various Babylonian creation stories, of both the Semitic Babylonian and the Sumerian material. Each creation account is preceded by a brief introduction dealing with the age and provenance of the tablets, the aim and purpose of the story, etc. Also included is a translation and discussion of two Babylonian creation versions written in Greek. The final chapter presents a detailed examination of the Babylonian creation accounts in their relation to our Old Testament literature.<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alexander Heidel
      </h2>
      
      <p class="authorDescription body article"><B>Alexander Heidel</B> was at the time of his death in 1955 on the research staff of the Oriental Institute, University of Chicago.<br></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?268efc5a